import { render, staticRenderFns } from "./InventorySession.vue?vue&type=template&id=c371afdc"
import script from "./InventorySession.vue?vue&type=script&lang=js"
export * from "./InventorySession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports